// reduce decisions to minimal set t be stored
// only features, that contain decisions and featureValues that are not undefined
export function getFilteredDecisions(decs) {
	return decs?.map(dec => (
			{
				variableId: dec.attributeId.localId,
				featureValue: dec.choiceValueId
			}
		)
	)
		.sort((a, b) => {
			if (a.variableId < b.variableId) {
				return -1;
			}
			if (a.variableId > b.variableId) {
				return 1;
			}
			return 0;
		});
}
